import { CxEvent } from '@spartacus/core'

export class PageViewEvent extends CxEvent {

  static readonly type = 'pageview'
  event = 'pageview'
  site: PageViewSite = {} as PageViewSite
  store: PageViewStore = {} as PageViewStore
  system: PageViewSystem = {} as PageViewSystem

  constructor () {
    super()
  }
}

export interface PageViewSite {
  contentGroup1?: string;
  contentGroup2?: string;
  contentGroup3?: string;
  contentGroup4?: string;
  contentGroup5?: string;
  country: string;
  language: string;
  pageType?: string;
  virtPath: string;
  virtTitle?: string;
  pageGoal?: string;
  businessSeg1?: string;
  businessSeg2?: string;
  businessSeg3?: string;
}

export interface PageViewStore {
  cart: string;
}

export interface PageViewSystem {
  view: string;
}
